import { createFileRoute } from "@tanstack/react-router";
import { EditFourniturePage } from "@/features/achats/components/fournitures/EditFourniturePage";

export const Route = createFileRoute("/_app/achats/fournitures/$id/edit")({
  staticData: {
    title: "Modifier fourniture",
    showInBreadcrumb: true,
  },
  component: EditFourniturePage,
});
